import type { Types as IdunSoftTypes } from '../types';
import type { OutTypes } from './schedules';

export default (teachers: IdunSoftTypes.teacher[]): OutTypes.teacher[] => {
  return teachers
    .reduce<OutTypes.teacher[]>((acc, teacher, index) => {
      const ids = teacher['ID'];
      if (!ids)
        throw new Error('A teacher does not have a unique key');

      if (acc.some(x => x.ids == ids))
        throw new Error(`A teacher ID "${ids}" exists multiple times at indices ${ index } and ${ acc.findIndex(x => x.ids == ids) }`);

      return acc.concat({
        ids:         ids,
        displayName: teacher['Namn']
      });
    }, []);
};